import createVueComponent from '../createVueComponent';

const Command = createVueComponent('CommandIcon', [
  [
    'path',
    {
      d:
        'M18 3a3 3 0 00-3 3v12a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3H6a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3V6a3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3h12a3 3 0 003-3 3 3 0 00-3-3z',
    },
  ],
]);

export default Command;
